import { render, staticRenderFns } from "./CompletePhysicianProfile.vue?vue&type=template&id=1e53ca52"
import script from "./CompletePhysicianProfile.vue?vue&type=script&lang=js"
export * from "./CompletePhysicianProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports